import { toast, ToastContainer } from 'react-toastify';
import axios from 'axios';

export const listAllReligionsService = async (language) => {
    try {
        return await axios.get(`${process.env.REACT_APP_API_URL}/api/religion/list_all/`+language)
        .then((response)=>{
            return response?.data
        }).catch((error)=>{
            console.log(error)
            return error.response.data.message || 'generic_server_error_message'
        })
    } catch (error) {
        toast.error('A server error ocurred.')
    }
}

